// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Modifier timing relative to the matched original message.
 */
export enum ModifierType {
  BEFORE = 0,
  AFTER = 1,
  IN_FLIGHT = 2,
}
